import React from "react";
import RenderOneDataMatrix from "./components/RenderOneDataMatrix";
import MultipleGeneratorLayout from "./components/common/MultipleGeneratorLayout";

const STORAGE_KEY = "multipleDMData";
const DEFAULT_DATA = ["https://phong.info", "EXAMPLE_CODE", "", ""];
const MAX_ITEMS = 40;

const MultipleDataMatrix: React.FC = () => {
  return (
    <MultipleGeneratorLayout
      storageKey={STORAGE_KEY}
      defaultData={DEFAULT_DATA}
      maxItems={MAX_ITEMS}
      itemName="D.Matrix"
      confirmClearMessage="Are you sure you want to clear all D.Matrix codes?"
      RenderComponent={RenderOneDataMatrix as any}
    />
  );
};

export default MultipleDataMatrix;
